// extracted by mini-css-extract-plugin
module.exports = {"box":"ContactBox-module--box--3Wr2N","contactIcon":"ContactBox-module--contactIcon--2_W7q","vertical":"ContactBox-module--vertical--hc7_G","link":"ContactBox-module--link--ntzyw"};